import { Box, Button, Input, Spinner, Text, useToast } from "@chakra-ui/react"
import axios from "axios"
import * as React from "react"
import { api } from "../../config"

const REQUIRED_HEADERS = [
  "Codice",
  "Nome",
  "Cognome",
  "Cf",
  "Address",
  "City",
  "Code",
  "Cap",
]

const PaymentPerson: React.FC = () => {
  const toast = useToast()

  const [file, setFile] = React.useState<File | null>(null)
  const [loading, setLoading] = React.useState(false)

  const inputRef = React.useRef<HTMLInputElement>(null)

  const validateCSV = async (file: File) => {
    const text = await file.text()

    const firstLine = text.split("\n")[0].replace("\r", "").trim()

    const headers = firstLine.split(",").map((h) => h.trim())

    if (headers.length !== REQUIRED_HEADERS.length) {
      return false
    }

    for (let i = 0; i < REQUIRED_HEADERS.length; i++) {
      if (headers[i] !== REQUIRED_HEADERS[i]) {
        return false
      }
    }

    return true
  }

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0]
    if (!selectedFile) return

    const valid = await validateCSV(selectedFile)

    if (!valid) {
      toast({
        title: "CSV format incorrect",
        description:
          "Header must be: Codice, Nome, Cognome, Cf, Address, City, Code, Cap",
        status: "error",
        position: "bottom-right",
      })

      if (inputRef.current) {
        inputRef.current.value = ""
      }

      setFile(null)
      return
    }

    setFile(selectedFile)
  }

  const removeFile = () => {
    setFile(null)

    if (inputRef.current) {
      inputRef.current.value = ""
    }
  }

  const handleUpload = async () => {
    if (!file) {
      toast({
        title: "Please select a CSV file",
        status: "warning",
        position: "bottom-right",
      })
      return
    }

    try {
      setLoading(true)

      const formData = new FormData()
      formData.append("file", file)

      await axios.post(`${api}/payment-people/import-csv`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      })

      toast({
        title: "CSV imported successfully",
        status: "success",
        position: "bottom-right",
      })

      removeFile()
    } catch (error: any) {
      toast({
        title:
          error.response?.data?.message || error.message || "Upload failed",
        status: "error",
        position: "bottom-right",
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box bg="blue.100" p="4" shadow="base" borderRadius="md" maxW="500px">
      <Text mb="2" fontWeight="bold">
        Upload Payment Person CSV
      </Text>

      <Input
        ref={inputRef}
        type="file"
        accept=".csv"
        bg="white"
        mb="3"
        onChange={handleFileChange}
      />

      {file && (
        <Text mb="2" fontSize="sm">
          Selected: {file.name}
          <Button size="xs" ml="2" colorScheme="red" onClick={removeFile}>
            Remove
          </Button>
        </Text>
      )}

      <Button
        colorScheme="blue"
        onClick={handleUpload}
        width="100%"
        isLoading={loading}
        disabled={loading}
      >
        {loading ? <Spinner size="sm" /> : "Upload CSV"}
      </Button>
    </Box>
  )
}

export default PaymentPerson